'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('../propTypes');

var _PreviewLink = require('./PreviewLink');

var _PreviewLink2 = _interopRequireDefault(_PreviewLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PreviewSection(_ref) {
  var navigationItem = _ref.navigationItem,
      navigationItems = _ref.navigationItems;

  var sectionItems = navigationItems.getNavigationItemsInSection(navigationItem.id);
  var links = sectionItems.map(function (item) {
    return _react2.default.createElement(_PreviewLink2.default, { navigationItem: item, key: item.id });
  });

  return _react2.default.createElement(
    'li',
    { className: 'nav-item dropdown' },
    _react2.default.createElement(
      'a',
      { className: 'nav-link dropdown-toggle', 'data-toggle': 'dropdown', role: 'button', 'aria-haspopup': 'true', 'aria-expanded': 'false' },
      navigationItem.title
    ),
    _react2.default.createElement(
      'div',
      { className: 'dropdown-menu' },
      links
    )
  );
}

PreviewSection.propTypes = {
  navigationItem: _propTypes.NavigationItemPropType.isRequired,
  navigationItems: _propTypes.NavigationItemStorePropType.isRequired
};

exports.default = PreviewSection;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/PreviewSection.js
// module id = 413
// module chunks = 0